//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "jifenshangcheng",
  data() {
    return {
      loadMark: false,
      last: false,
      search: '',
      imgUrl: "",
      imgMark: "",
      loading: false,
      title: 0,
      total: 0,
      page: 1,
      last_page: '',
      quantity: 10,
      content: [],
      scroller: [],
      content1: [],
      scroller1: [],
      timeoutObj: null,
      inputChange: false
    };
  },
  methods: {
    onCancel() {
      console.log(this.search)
      this.search = ''
      this.page = 1
       this.last_page = ''
       this.init()
    },
    onChange() {
      this.page = 1
      console.log(this.page)
      this.loadMark = true
      this.inputChange = true
      this.last_page = ''
      // this.timeoutObj = setTimeout(() => {
        // this.timeoutObj && clearTimeout(this.timeoutObj)
        this.init()
      // },500)
    },
    bigImg(val) {
      this.imgMark = true;
      this.imgUrl = val.image;
    },
    onItemClick: function() {
      this.loadMark = false
      this.search = ''
      this.page = 1;
      this.last_page = '';
      // this.last_page = 0;
      this.quantity = 10;
      this.content = [];
      this.scroller = [];
      this.content1 = [];
      this.scroller1 = [];
      if (this.title === 0) {
        this.init();
      } else if (this.title === 1) {
        this.init1();
      }
    },
    onScrollBottom: function() {
      if (this.loading === true) {
        return;
      } else {
        this.loading = true;
        setTimeout(() => {
          this.init();
         
          this.loading = false;
        }, 1000);
      }
    },
    onScrollBottom1: function() {
      if (this.loading === true) {
        return;
      } else {
        this.loading = true;
        setTimeout(() => {
          this.init1();
          if (this.page !== this.last_page) {
            ++this.page;
          }
          this.loading = false;
        }, 1000);
      }
    },
    math: function() {
      let num = [];
      num = this.content.map((item, index) => {
        return item.gift_integral * item.gift;
      });
      this.total = num.reduce((item, index) => {
        return item + index;
      });
    },
    determine(val) {
      let title,
        content,
        id = val.id;
      if (val.pickup_address) {
        title = "取件";
        content = val.pickup_address;
      } else {
        title = "收货";
        content = "";
      }
      this.$vux.confirm.show({
        title: `${title}地址`,
        showInput: content ? false : true,
        content: content,
        confirmText: "确认兑换",
        onConfirm: data => {
          this.$HTTP
            .HttpPost("/Member/integral/giftExchange", {
              gift: id,
              shipping_address: content ? "" : data
            })
            .then(data => {
              this.$vux.toast.show({
                text: data.data.msg,
                type: "text",
                width: "80%",
                isShowMask: true
              });
            });
        }
      });
    },
    init: function() {
      console.log(this.last_page + 1);
      console.log(this.page);
      if (this.last_page + 1 === this.page && !this.search) {
        this.last = true
        this.loadMark = false
        return;
      }
      this.last = false
      this.$HTTP
        .HttpPost("/Member/integral/getGiftList", {
          page: this.page,
          quantity: this.quantity,
          search: this.search
        })
        .then(data => {
          
          this.loadMark = false
          this.last_page = data.data.data.last_page;
          this.content = data.data.data.data;
          console.log('page=' + this.page)
          this.scroller = this.page === 1 ? [...this.content] : [...this.scroller, ...this.content];
          if (!this.inputChange ) {
            ++this.page;
          }
          this.inputChange = false
        });
    },
    init1: function() {
      if (this.last_page === this.page) {
        return;
      }
      this.$HTTP
        .HttpPost("/Member/integral/getExchangeList", {
          page: this.page,
          quantity: this.quantity
        })
        .then(data => {
          this.last_page = data.data.data.last_page;
          this.content1 = data.data.data.data;
          this.scroller1 = [...this.scroller1, ...this.content1];
          for (let i in this.scroller1) {
            if (this.scroller1[i].status == 0) {
              this.scroller1[i].status = "已申请";
            } else if (this.scroller1[i].status == 1) {
              this.scroller1[i].status = "通过";
            } else if (this.scroller1[i].status == 2) {
              this.scroller1[i].status = "不通过";
            }
          }
        });
    }
  },
  mounted() {  },
  activated(){
    this.init();
  }
};



// WEBPACK FOOTER //
// ./src/components/jifenshangcheng.vue